import { render, staticRenderFns } from "./MinstmarcajeForm.vue?vue&type=template&id=fa064928"
import script from "./MinstmarcajeForm.vue?vue&type=script&lang=js"
export * from "./MinstmarcajeForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports